<!-- Content
================================================== -->
<div class="container margin-top-20">
  <div class="row">
 <div class="col-lg-4 col-md-5 col-sm-12">
   <div class="user-profile-box">

  <div class="header clearfix">
    <h3>{{UserFullName}}</h3>
    <img [src]="ProfileImageUrl" alt="UserName" class="img-fluid profile-img">
  </div>

  <div class="detail clearfix">
    <ul class="my-account-nav">
   <li class="sub-nav-title">Manage Account</li>
   <li><a [routerLink]="'/account/profile'"><i class="sl sl-icon-user"></i> My Profile</a></li>
   <!-- <li><a [routerLink]="'/account/bookmarks'"><i class="sl sl-icon-star"></i> Bookmarked Listings</a></li> -->
    </ul>

    <ul class="my-account-nav">
   <li class="sub-nav-title">Manage Listings</li>
   <li><a [routerLink]="'/account/properties'"><i class="sl sl-icon-docs"></i> My Properties</a></li>
   <li><a [routerLink]="'/property/forms/submit'"><i class="sl sl-icon-action-redo"></i> Submit New Property</a></li>
    </ul>
    <ul class="my-account-nav no-border-bottom">
   <li><a [routerLink]="'/account/change-password'" class="current"><i class="sl sl-icon-lock"></i> Change
    Password</a></li>
   <li><a [routerLink]="'/'" (click)="Logout()"><i class="sl sl-icon-power"></i> Log Out</a></li>
    </ul>
  </div>
   </div>
 </div>
 <div class="col-lg-8 col-md-7 col-sm-12">
   <div class="notification notice closeable">
  <div class="form-group pl-10">
    <h3>Change Password </h3>
  </div>
   </div>
    <form (ngSubmit)="Submit(changePasswordForm)" class="submit-section" #changePasswordForm="ngForm">
  <div class="row">
    <div class="col-md-8">
   <div class="form-group" [class.has-error]="currentPasswordControl.invalid && currentPasswordControl.touched"
     [class.has-success]="currentPasswordControl.valid">
     <label for="currentPassword" class="control-label">Current Password:<i class="fa fa-asterisk"></i></label>
     <input type="password" maxlength="35"  name="currentPassword" class="form-control input-text"
    [(ngModel)]="currentPassword" required #currentPasswordControl="ngModel" />
     <div class="notification error" *ngIf="currentPasswordControl.invalid && currentPasswordControl.touched">
    <p>Current password is required.</p>
     </div>
   </div>
    </div>
  </div>
  <div class="row margin-top-20">
    <div class="col-md-8">
   <div class="form-group" [class.has-error]="newPasswordControl.invalid && newPasswordControl.touched"
     [class.has-success]="newPasswordControl.valid">
     <label for="newPassword" class="control-label">Confirm Password:<i class="fa fa-asterisk"></i></label>
     <input type="password" maxlength="35" name="newPassword" class="form-control input-text" [(ngModel)]="newPassword"
    required #newPasswordControl="ngModel" />
     <div class="notification error" *ngIf="newPasswordControl.invalid && newPasswordControl.touched">
    <p>New password is required.</p>
     </div>
   </div>
    </div>
  </div>
  <div class="row margin-top-20">
    <div class="col-md-8">
   <div class="form-group" [class.has-error]="confirmPasswordControl.invalid && confirmPasswordControl.touched"
     [class.has-success]="confirmPasswordControl.valid">
     <label for="confirmPassword" class="control-label">Confirm Password:<i class="fa fa-asterisk"></i></label>
     <input type="password" maxlength="35" name="confirmPassword" class="form-control input-text"
    [(ngModel)]="confirmPassword" required #confirmPasswordControl="ngModel" />
     <div class="notification error" *ngIf="confirmPasswordControl.invalid && confirmPasswordControl.touched">
    <p>Confirm password is required.</p>
     </div>
   </div>
    </div>
  </div>
  <div class="row margin-top-20">
    <div class="col-md-12">
   <input type="submit" class="submit button" id="submit" value="Update Password"
     [disabled]="changePasswordForm.invalid" />
    </div>
  </div>
   </form>
 </div>
  </div>
</div>
